import { selectBasketInitImage } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import Warehouse from 'components/Warehouse'
import { useSelector } from 'react-redux'

const type = process.env.REACT_APP_TYPE

const FirstSlide = ({ nextPage }) => {
  const initImage = useSelector(selectBasketInitImage)
  const { t } = useTranslation('newWarehouse')
  return (
    <>
      <i className='icon icon--logo s24' />
      <div className='slide__title center'>
        <div className='--secFont'>{t('congratulations')}</div>
        <div>{t(initImage?.type === 'parking' ? 'youHaveRentedYourParkingSpace' : `youHaveRentedYourMag.${type}`)}</div>
      </div>

      <div className='fireworks'>
        <div />
        <div />
      </div>

      {initImage?.src
        ? <div className='slide__image'>
          <img
            alt='box'
            src={initImage.src}
          />
        </div>
        : <Warehouse
          showShadow
          rentableType={initImage?.type === 'parking' ? 'parking' : 'warehouse'}
        />}

      <div className='slide__desc'>
        <div>{t('youAreOnTheFinalStretch')}</div>
        <div>{t('youNeedToConfigureYourPanelNow')}</div>
      </div>

      <Submit text={t('letsStart')} action={nextPage} />
    </>
  )
}

export default FirstSlide